import React from 'react';
import { useSelector } from 'react-redux';
import { modalsSelector } from '../../selectors';
import { CategoryModal } from './CategoryModal';
import GoodModal from './GoodModal';
import { ModificationModal } from './ModificationModal';
import { RegionPriceModal } from './RegionPriceModal';
import SliderModal from './SliderModal';
import StopList from './StopList';
import YooKassaModal from './YooKassaModal';
import SearchOrderModal from './SearchOrderModal';
import ChangeLogOrderModal from './ChangeLogOrderModal';
import HistoryOrdersModal from './HistoryOrdersModal';
import WorkingShiftAddArticles from './WorkingShiftAddArticles';
import OtherExpendituresAddArticles from './OtherExpendituresAddArticles';
import OtherExpendituresEditArticles from './OtherExpendituresEditArticles';
import CorrectionModal from './CorrectionModal';
import PromotionsModal from './PromotionsModal';
import ClientModal from './ClientModal';
import RawModal from './RawModal';
import ProductCategoryModal from './ProductCategoryModal';
import { ReceipeModal } from './ReceipeModal';
import ChangeLogAccounting from './ChangeLogAccounting';
import MarkedGoodsModal from './MarkedGoodsModal';
import ChangeLogPlannedRevenueModal from './ChangeLogPlannedRevenueModal';
import AutoConsumptionModal from './AutoConsumptionModal';
import LoaderKKTModal from './LoaderKKTModal';
import ChangeCashModal from './ChangeCashModal';
import WorkingShiftModal from './WorkingShiftModal';
import WorkingShiftRefundArticles from './WorkingShiftRefundArticles';
import RefundOrderModal from './RefundOrderModal';
import GroupModal from './GroupModal';

const modals = {
  category: <CategoryModal key="category_modal" />,
  good: <GoodModal key="good_modal" />,
  stopList: <StopList key="stopListModal" />,
  regionPrice: <RegionPriceModal key="regionPriceModal" />,
  modification: <ModificationModal key="modificationModal" />,
  recipes: <ReceipeModal key="recipeModal" />,
  slider: <SliderModal key="sliderModal" />,
  yookassa: <YooKassaModal key="kassaModal" />,
  orderSearch: <SearchOrderModal key='searchOrderModal'/>,
  changeLogOrder: <ChangeLogOrderModal key='changeLogOrder'/>,
  historyOrders: <HistoryOrdersModal key='historyOrders'/>,
  client: <ClientModal key='client'/>,
  workingShiftAddArticles: <WorkingShiftAddArticles key='workingShiftAddArticles'/>,
  otherExpendituresAddArticles: <OtherExpendituresAddArticles key='otherExpendituresAddArticles'/>,
  otherExpendituresEditArticles: <OtherExpendituresEditArticles key='otherExpendituresEditArticles'/>,
  correctionModal: <CorrectionModal key='correctionModal'/>,
  promotionsModal: <PromotionsModal key='promotionsModal'/>,
  modalRaw: <RawModal key='rawModal' />,
  productCategory: <ProductCategoryModal key='productCategory'/>,
  changeLogAccountingModal: <ChangeLogAccounting key='changeLogAccountingModal'/>,
  markedGoods: <MarkedGoodsModal key='markedGoods' />,
  changeLogPlannedRevenue: <ChangeLogPlannedRevenueModal key='changeLogPlannedRevenue'/>,
  autoConsumption: <AutoConsumptionModal key='autoConsumption'/>,
  loaderKKTModal: <LoaderKKTModal key='loaderKKTModal'/>,
  changeCashModal: <ChangeCashModal key='changeCashModal'/>,
  workingShiftModal: <WorkingShiftModal key='workingShiftModal'/>,
  workingShiftRefundArticles: <WorkingShiftRefundArticles key='workingShiftRefundArticles'/>,
  refundOrderModal: <RefundOrderModal key='refundOrderModal'/>,
  groupgood: <GroupModal key='groupgood'/>,
};

export function Modals() {
  const stateModals = useSelector(modalsSelector);

  if (Object.keys(stateModals).some((key) => stateModals[key])) {
    return (
      <>
        {Object.keys(modals).filter((key) => stateModals[key]).map((key) => modals[key])}
        <div className="modal-backdrop fade show" />
      </>
    );
  }

  return null;
}
